<template>
    <article
        id="policy-details-insured-item"
        data-test-policy-insured-item
    >
        <h2>{{ value.LabelInsuredItemHeadline }}</h2>

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatTypeName"
            name="boatTypeName"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatLocation"
            name="boatLocation"
        />

        <field
            v-if="value.ShowHabourGroupField"
            v-model="value.HarborGroup"
            name="harborGroup"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatMake"
            name="boatMake"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatValue"
            name="boatValue"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatBuildYear"
            name="boatBuildYear"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatConstructionMaterial"
            name="boatConstructionMaterial"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatHullNumber"
            name="boatHullNumber"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.BoatLength"
            name="boatLength"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.HasCertificate"
            name="hasCertificate"
        />

        <field
            v-if="value.ShowMotorBoatFields"
            v-model="value.HasGPS"
            name="hasGPS"
        />

        <field
            v-if="value.ShowBoatEngineFields"
            v-model="value.EngineInformationTitle"
            name="engineInformationTitle"
        />

        <field
            v-if="value.ShowBoatEngineFields"
            v-model="value.EngineMake"
            name="engineMake"
        />

        <field
            v-if="value.ShowBoatEngineFields"
            v-model="value.EngineNumber"
            name="engineNumber"
        />

        <field
            v-if="value.ShowBoatEngineFields"
            v-model="value.EngineHorsePower"
            name="engineHorsePower"
        />

        <field
            v-if="value.ShowBoatEngineFields"
            v-model="value.EngineMaxSpeed"
            name="engineMaxSpeed"
        />

        <field
            v-if="value.ShowBoatEngineFields"
            v-model="value.EngineType"
            name="engineType"
        />

        <field
            v-if="value.ShowMinorBoatTypeFields"
            v-model="value.AssetDescriptionMinorBoatTypes"
            name="assetDescriptionMinorBoatTypes"
        />

        <field
            v-if="value.ShowMinorBoatTypeFields"
            v-model="value.MinorBoatTypeValue"
            name="minorBoatTypeValue"
        />
    </article>
</template>

<script>
import Field from '../Field.vue';

export default {
    name: 'Boat',
    components: {
        Field
    },
    props: {
        value: {
            type: Object,
            default() {
                return null;
            }
        }
    }
};
</script>
